export default {
  clientID: 'AlMurabaCMS_App',
  tokenSchema: '/connect',
  apiSchema: '/api',
  baseURL: 'https://cmsapi.muraba.iq',
};
